import { render, staticRenderFns } from "./AssessmentDetail.vue?vue&type=template&id=1f61e100&scoped=true"
import script from "./AssessmentDetail.vue?vue&type=script&lang=js"
export * from "./AssessmentDetail.vue?vue&type=script&lang=js"
import style0 from "./AssessmentDetail.vue?vue&type=style&index=0&id=1f61e100&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f61e100",
  null
  
)

export default component.exports